import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import companies from "../../services/companies.js";
import security from "../../services/security.js";
import env from "../../services/env.js";

class ProfilesController {
  constructor($http, $localStorage, $timeout, $rootScope, $location, $state, AuthService, SecurityService, $stateParams) {
    this.name = "profiles";

    $localStorage.activeStateName = "profiles";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$location = $location;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.$rootScope = $rootScope;
    this.arrayForGallery = [];
    this.$auth = AuthService;
    this.remain_loading_count = 0;
    this.$security = SecurityService;
    this.currentUser = this.$auth.getUserData();
    this.showGallery = false;
    this.rand = Math.floor(Math.random() * (2 - 0 + 1)) + 0;
    this.pages = [];
    var _this = this;
    this.currentPageNumber = 1;

    console.log("state paraams?");
    console.dir(_this.$state);
    console.dir(_this.$stateParams);

    _this.$security.getJobbler(_this.$stateParams.profileId).then(function (response) {
      console.log("response");
      console.dir(response);
      _this.jobbler = response.data;
      _this.calculatePagination();
      _this.getSocialLinks();
      _this.rating = _this.$security.getJobblerStars(_this.jobbler);
      _this.collectPhotosForGallery();
      _this.getAge();
      _this.$security.getRatings(_this.jobbler.id, 0).then(function (response) {
        console.log("get ratings response");
        console.dir(response);

        _this.ratings = response.data.ratings;
      });
    });

    this.$rootScope.$on("CloseGallery", function ($event, params) {
      _this.gallery();
    });
  }

  randomPicture() {
    var arrayOfPix = [
      "/app/vendor/images/background-prof-pic.jpg",
      "/app/vendor/images/background-prof-pic2.png",
      "/app/vendor/images/background-prof-pic3.png",
    ];

    console.log("whta is the random number...");
    console.dir(this.rand);

    return arrayOfPix[this.rand];

    //return "/app/vendor/images/background-prof-pic3.png";
  }

  handleJobblerProfile(params) {
    var _this = this;

    _this.jobbler = params.jobbler;
  }

  displayPicture(jobbler) {
    var _this = this;

    if (jobbler) {
      for (var i = 0; i < jobbler.picture1s.length; i++) {
        if (jobbler.picture1s[i].indexOf("160x160") > -1) {
          return jobbler.picture1s[i];
          break;
        }
      }
    }
  }

  getSocialLinks() {
    var _this = this;

    var socials = {};
    var notNullVals = 0;
    var nullVals = 0;
    socials.instagram = _this.jobbler.instagram;
    socials.googlePlus = _this.jobbler.googlePlus;
    socials.twitter = _this.jobbler.twitter;
    socials.facebook = _this.jobbler.facebook;
    socials.linkdedIn = _this.jobbler.linkdedIn;

    var keys = Object.keys(socials);
    var values = keys.map(function (v) {
      return socials[v];
    });
    try {
      for (var x = 0; x < keys.length; x++) {
        if (socials[keys[x]] === null) {
          nullVals = nullVals + 1;
        } else {
          notNullVals = notNullVals + 1;
        }
      }
    } finally {
      if (notNullVals === 0) {
        _this.showIcons = false;
      } else {
        _this.showIcons = true;
        _this.socials = socials;
      }
    }
  }

  calcRating(r) {
    var _this = this;

    var rating = "";

    if (r.rate === 0) {
      rating = "one";
    }
    if (r.rate === 1) {
      rating = "one";
    }
    if (r.rate === 2) {
      rating = "two";
    }
    if (r.rate === 3) {
      rating = "three";
    }
    if (r.rate === 4) {
      rating = "four";
    }
    if (r.rate === 5) {
      rating = "five";
    }

    return rating;
  }

  paginateRatings(page) {
    var _this = this;

    var offset = page * 5 - 5;

    _this.$security.getRatings(_this.jobbler.id, offset).then(function (response) {
      _this.ratings = response.data.ratings;
    });
  }

  calculatePagination() {
    var _this = this;

    var numberOfReviews = Math.ceil(_this.jobbler.numberOfCompletedJobbles / 5);

    for (var i = 0; i < numberOfReviews; i++) {
      _this.pages.push(i + 1);
    }
  }

  gallery() {
    var _this = this;

    if (_this.showGallery) {
      _this.showGallery = false;
    } else {
      _this.showGallery = true;
      _this.$timeout(function () {
        _this.$rootScope.$emit("CollectPhotos", {
          dataprof: _this.arrayForGallery,
        });
      });
    }
  }

  collectPhotosForGallery() {
    var _this = this;

    console.log("collectPhotosForGallery");
    console.dir(_this.jobbler);

    var arrayOfPhotos = [];

    if (_this.jobbler.picture1s) {
      arrayOfPhotos.push(_this.jobbler.picture1s);
    }
    if (_this.jobbler.picture2s) {
      arrayOfPhotos.push(_this.jobbler.picture2s);
    }
    if (_this.jobbler.picture3s) {
      arrayOfPhotos.push(_this.jobbler.picture3s);
    }
    if (_this.jobbler.picture4s) {
      arrayOfPhotos.push(_this.jobbler.picture4s);
    }
    if (_this.jobbler.picture5s) {
      arrayOfPhotos.push(_this.jobbler.picture5s);
    }
    if (_this.jobbler.picture6s) {
      arrayOfPhotos.push(_this.jobbler.picture6s);
    }

    var count = arrayOfPhotos.length;

    try {
      for (var i = 0; i < count; i++) {
        for (var x = 0; x < arrayOfPhotos[i].length; x++) {
          if (arrayOfPhotos[i][x].indexOf("800x800") > -1) {
            _this.arrayForGallery.push(arrayOfPhotos[i][x]);
          }
        }
      }
    } finally {
    }
  }

  getAge() {
    var _this = this;
    _this.jobbler.age = moment().diff(moment(_this.jobbler.dateBirth), "years");
  }
}

ProfilesController.$inject = ["$http", "$localStorage", "$timeout", "$rootScope", "$location", "$state", "auth", "security", "$stateParams"];

export default ProfilesController;



// WEBPACK FOOTER //
// ./client/app/components/profiles/profiles.controller.js